import React from 'react';

import { flagStyles } from '../settings';

const SvgBI = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-528px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBI;
